import { render, staticRenderFns } from "./AgentsInfoSvg.vue?vue&type=template&id=458961c6"
import script from "./AgentsInfoSvg.vue?vue&type=script&lang=js"
export * from "./AgentsInfoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports